/**
 * Sentinel a guard can pass to next() to end the chain immediately with a plain allow,
 * skipping any remaining guards. Distinct from calling next() with no arguments, which
 * only continues to the next guard in the chain.
 */
export const ALLOW = Symbol('composeGuards.allow');

/**
 * Chains multiple Vue Router navigation guards so they run in sequence, short-circuiting
 * on the first one that redirects/aborts (a defined, non-ALLOW result) or explicitly
 * allows via next(ALLOW), instead of calling next() with no arguments to continue.
 */
const composeGuards = (...guards) => (to, from, next) => {
  const runGuard = (index) => {
    if (index >= guards.length) {
      next();
      return;
    }
    guards[index](to, from, (result) => {
      if (result === undefined) {
        runGuard(index + 1);
      } else if (result === ALLOW) {
        next();
      } else {
        next(result);
      }
    });
  };
  runGuard(0);
};

export default composeGuards;
